export const Arrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="54"
      viewBox="0 0 65 54"
      fill="none"
    >
      <path
        d="M0.292896 8.71614C-0.0976334 8.32562 -0.0976334 7.69245 0.292896 7.30193L6.65686 0.937965C7.04738 0.547441 7.68055 0.547441 8.07107 0.937965C8.46159 1.32849 8.46159 1.96165 8.07107 2.35218L2.41422 8.00903L8.07107 13.6659C8.46159 14.0564 8.46159 14.6896 8.07107 15.0801C7.68055 15.4706 7.04738 15.4706 6.65686 15.0801L0.292896 8.71614ZM63 54C63 42.1707 60.757 33.5078 57.0533 27.1493C53.3569 20.8033 48.1632 16.6794 42.1232 13.9911C29.9559 8.5756 14.4616 9.00903 1 9.00903V7.00903C14.2845 7.00903 30.2902 6.53522 42.9364 12.1639C49.3031 14.9976 54.8445 19.3836 58.7815 26.1427C62.7112 32.8892 65 41.9265 65 54H63Z"
        fill="#E25D2A"
      />
    </svg>
  );
};
